import React from 'react';

import Container from '@src/components/Shared/Container';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';

import { MultiQuotesPropTypes } from './MultiQuotes.types';

const MultiQuotes: React.FC<MultiQuotesPropTypes> = ({ attr, id, testimonials }) => {
  return (
    <Container attr={attr} id={id}>
      <div className='grid gap-[2.4rem] md:grid-cols-2 md:gap-[2.7rem] lg:grid-cols-3'>
        {testimonials?.map((testimonial) => {
          return (
            <div
              key={`${testimonial?.sys?.id}-testimonial`}
              className='flex min-w-0 w-full flex-col justify-between rounded-[2.6rem] border-[0.1rem] border-border bg-[#FAFAFA] p-[3rem] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]'
            >
              <div>
                <p
                  className='heading-[2.4rem] mb-[2rem] text-[1.4rem] font-normal uppercase text-primary'
                  style={{
                    textShadow:
                      'rgb(143, 66, 0, 0.2) 1px 0px 0px, rgb(143, 66, 0, 0.2) 0.540302px 0.841471px 0px',
                  }}
                >
                  {testimonial?.title}
                </p>

                <RenderBodyCopy
                  className='mb-[4rem] text-[1.6rem] text-body-copy font-light 3xl:text-[1.8rem]'
                  bodyCopy={testimonial.bodyCopy?.json?.content}
                />
              </div>

              <div className='flex items-center justify-between gap-[1rem] md:gap-[2.4rem]'>
                <div className='min-w-0'>
                  <h3 className='mb-[0.6rem] text-[1.2rem] font-medium text-primary md:text-[1.8rem]'>
                    {testimonial?.name}
                  </h3>

                  <p className='text-[1.2rem] font-normal leading-[1.2] text-body-copy--dark md:text-[1.8rem] md:leading-[1.2]'>
                    {testimonial?.company}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default MultiQuotes;
